<template>
  <div id="faq-search" class="faq-search u-12/12@xs u-8/12@md u-push-2/12@md u-relative@xs u-absolute@md">
    <div class="faq-search__input-wrapper">
      <VueTagsInput
        v-model="tag"
        :placeholder="placeholder"
        :tags="tags"
        :max-tags="10"
        :add-on-key="[13, 32, ',']"
        :avoid-adding-duplicates="false"
        class="search-tags"
        @tags-changed="updateTags"
      />
      <ElButton v-show="keywords.length" class="clear-button" type="text" @click="clear">
        <i class="fa fa-times-circle" />
      </ElButton>
      <ElButton class="search-button" @click="search">
        <i class="fa fa-search u-color--quaternary" />
      </ElButton>
    </div>
    <div :class="{ 'show-results': showResults }" class="faq-search__results">
      <div v-loading="loading" style="margin-top: 60px;">
        <ElCollapse v-if="results.length > 0" accordion>
          <ElCollapseItem v-for="(result, index) in results" :key="index" :title="result.title" :name="index">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="result.answer" />
            <p class="municipality-wrapper">
              <span v-for="(item, idx) in result.municipalities" :key="idx" class="municipality">
                <a :href="item.url">{{ item.title }}</a>
              </span>
            </p>
          </ElCollapseItem>
        </ElCollapse>
        <p v-else>
          Geen resultaten gevonden
        </p>
      </div>
      <FeedbackForm :payload="{ keywords: keywords }" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueTypes from 'vue-types'
import { Button, Collapse, CollapseItem, Loading } from 'element-ui'
import { VueTagsInput } from '@johmun/vue-tags-input'
import axios from 'axios'
import FeedbackForm from '../../components/FeedbackForm.vue'

Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service

export default {
  name: 'FaqSearchBar',

  components: {
    ElButton: Button,
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
    FeedbackForm,
    VueTagsInput
  },

  props: {
    municipality: VueTypes.number.def(1).isRequired,
    faqSearchApiUrl: VueTypes.string.def('').isRequired,
    faqFeedbackApiUrl: VueTypes.string.def('').isRequired
  },

  data() {
    return {
      showResults: false,
      tag: '',
      tags: [],
      loading: false,
      results: [],
      feedback: '',
      feedbackSent: false
    }
  },

  computed: {
    keywords() {
      const tags = []
      this.tags.forEach(item => {
        tags.push(item.text)
      })
      return tags
    },
    placeholder() {
      return this.tags.length === 0 ? 'Voer je zoektermen in' : ''
    }
  },

  mounted() {
    document.addEventListener('click', this.unfocusSearch)
    document.querySelector('.ti-new-tag-input').focus()
  },

  beforeDestroy() {
    document.removeEventListener('click', this.unfocusSearch)
  },

  methods: {
    clear() {
      this.tags = []
      this.showResults = false
      this.feedbackSent = false
      document.querySelector('.ti-new-tag-input').focus()
    },
    updateTags(newTags) {
      this.tags = newTags
      if (newTags.length > 0) {
        this.search()
      } else {
        this.showResults = false
      }
      document.querySelector('.ti-new-tag-input').focus()
    },
    search() {
      if (this.keywords.length > 0) {
        this.showResults = true
        this.loading = true
        axios.get(this.faqSearchApiUrl + '?municipality=' + this.municipality + '&query=' + this.keywords.join()).then(result => {
          if (result.status === 200) {
            this.results = result.data.data
          }
          this.loading = false
        })
      }
    },
    unfocusSearch(event) {
      const searchWrapper = document.getElementById('faq-search')
      const insideElement = () => {
        return searchWrapper !== null && searchWrapper.contains(event.target)
      }
      if (!insideElement() && this.showResults) {
        this.showResults = false
      }
    }
  }
}
</script>
